const LinkType = Object.freeze({
  1: { description: 'Logo', icon: '', lineNumber: 1 },
  2: { description: 'Regulamin', icon: 'fa-file-text-o', lineNumber: 2 },
  3: { description: 'Wyniki', icon: 'fa-trophy', lineNumber: 3 },
  4: { description: 'Strona Internetowa', icon: 'fa-internet-explorer', lineNumber: 4 },
  5: { description: 'Mapy', icon: 'fa-map-o', lineNumber: 5 },
  6: { description: 'Wzorcówki', icon: 'fa-map', lineNumber: 6 },
  7: { description: 'Protokół', icon: 'fa-file-text', lineNumber: 7 },
});

export default LinkType;
